/** Sidebar entries that must appear even when an older saved accessConfig omits them. */
export const REQUIRED_SIDEBAR_ITEMS = [
  {
    title: "Support",
    id: "12",
    auth: true,
    to: "/problematikat",
    after: "/lajmerimet",
    // All roles — employees submit own tickets; admins resolve.
  },
  {
    title: "Planifikuesi",
    id: "3c",
    auth: true,
    to: "/pushimet/planer",
    after: "/orari",
    // Employees: read-only own leave. Supervisors: their reports. Admins: all.
    roles: [
      "admin",
      "super admin",
      "supervisor",
      "branch manager",
      "employee",
    ],
  },
  {
    title: "Analitika",
    id: "5b",
    auth: true,
    to: "/analitika",
    after: "/raportet",
    roles: ["admin", "super admin", "branch manager"],
  },
];

function normalizeRole(role) {
  return String(role || "")
    .toLowerCase()
    .trim();
}

/**
 * Merge required items into a user's sidebarConfig without duplicating paths.
 * Inserts after `after` when present, otherwise appends.
 * Dedupes by `to` only — sidebar ids are historically non-unique in this app.
 */
export function ensureSidebarItems(sidebarConfig = [], userRole) {
  const config = Array.isArray(sidebarConfig) ? [...sidebarConfig] : [];
  const role = normalizeRole(userRole);

  const looksAdmin = config.some((el) =>
    ["/aprovimet", "/konfigurimet", "/punonjesit"].includes(el?.to)
  );

  REQUIRED_SIDEBAR_ITEMS.forEach((item) => {
    const roleOk = !item.roles?.length || item.roles.includes(role);
    if (!roleOk && !looksAdmin) return;

    const existingIdx = config.findIndex((el) => el?.to === item.to);
    const entry = {
      title: item.title,
      id: item.id,
      auth: true,
      to: item.to,
    };

    if (existingIdx >= 0) {
      // Normalize title/auth if the saved row is incomplete.
      config[existingIdx] = { ...config[existingIdx], ...entry };
      return;
    }

    const afterIdx = item.after
      ? config.findIndex((el) => el?.to === item.after)
      : -1;
    if (afterIdx >= 0) config.splice(afterIdx + 1, 0, entry);
    else config.push(entry);
  });

  const seenTo = new Set();
  return config.filter((el) => {
    if (!el?.to) return true;
    if (seenTo.has(el.to)) return false;
    seenTo.add(el.to);
    return true;
  });
}
